import { useEffect, useState } from 'react';

import { getPlatformInfo } from '@/utils/platformDetection';

/**
 * Hook to determine if the Android app download prompt should be shown
 * 
 * The prompt is shown when:
 * 1. User is accessing the app via Android web browser (not native app)
 * 
 * The prompt is shown immediately on app load, before authentication.
 * 
 * @returns {boolean} shouldShow - Whether to display the Android app prompt
 */
export function useAndroidAppPrompt(): boolean {
  const [shouldShow, setShouldShow] = useState(false);

  useEffect(() => {
    // Check immediately on mount - no need to wait for authentication
    const platformInfo = getPlatformInfo();
    const isAndroidWeb = platformInfo.isWeb && platformInfo.webBrowser === 'android';
    
    // Show prompt to all Android web users, regardless of authentication status
    setShouldShow(isAndroidWeb);
  }, []);

  return shouldShow;
}

